import { getTabbableNodes as D } from "./utils/DOMutils.js";
function i(n) {
  if (!n)
    return null;
  if (typeof WeakRef > "u")
    return function() {
      return n || null;
    };
  var r = n ? new WeakRef(n) : null;
  return function() {
    return (r == null ? void 0 : r.deref()) || null;
  };
}
var R = function(n) {
  if (!n)
    return null;
  for (var r = [], e = n; e && e !== document.body; )
    r.push({
      current: i(e),
      parent: i(e.parentElement),
      left: i(e.previousElementSibling),
      right: i(e.nextElementSibling)
    }), e = e.parentElement;
  return {
    element: i(n),
    stack: r,
    ownerDocument: n.ownerDocument
  };
}, S = function(n) {
  var r, e, v, d, a;
  if (n)
    for (var b = n.stack, k = n.ownerDocument, s = /* @__PURE__ */ new Map(), c = 0, h = b; c < h.length; c++) {
      var t = h[c], u = (r = t.parent) === null || r === void 0 ? void 0 : r.call(t);
      if (u && k.contains(u)) {
        for (var l = (e = t.left) === null || e === void 0 ? void 0 : e.call(t), m = t.current(), f = u.contains(m) ? m : void 0, x = (v = t.right) === null || v === void 0 ? void 0 : v.call(t), g = D([u], s), o = (
          // that is element itself
          (a = (d = f ?? // or something in it's place
          (l == null ? void 0 : l.nextElementSibling)) !== null && d !== void 0 ? d : (
            // or somebody to the right, still close enough
            x
          )) !== null && a !== void 0 ? a : (
            // or somebody to the left, something?
            l
          )
        ); o; ) {
          for (var w = 0, p = g; w < p.length; w++) {
            var E = p[w];
            if (o != null && o.contains(E.node))
              return E.node;
          }
          o = o.nextElementSibling;
        }
        if (g.length)
          return g[0].node;
      }
    }
}, F = function(n) {
  var r = R(n);
  return function() {
    return S(r);
  };
};
export {
  F as captureFocusRestore,
  R as recordElementLocation
};
